var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-wrapper"},[_c('h1',{class:[("section-title_" + _vm.fontColor), 't-section-title-lg']},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('hr',{class:("" + _vm.lineColor)})])}
var staticRenderFns = []

export { render, staticRenderFns }